<template>
<div>
	<v-layout class="column carousel-slider-container">
		<SubsectionViewer />
		<!-- <router-view></router-view> -->
	</v-layout>
</div>
</template>

<script>
import SubsectionViewer from "@/components/carousel/SubsectionViewer";

export default {
	name: "CityEvents",
	components: {
		SubsectionViewer
	},
	computed: {
		isEventDetailsActive(){
			return (this.$route.name == 'cityeventdetails')
		}
	}
};
</script>

<style scoped lang="scss">
</style>
